module.exports = __webpack_public_path__ + "static/media/skull-popup.c31e679e.png";